import { defineMessages } from 'react-intl'

export default defineMessages({
  saveButton: {
    id: 'EditLegalEntityFormPresenter.saveButton',
    defaultMessage: 'Save',
  },
  errorToastTitle: {
    id: 'EditLegalEntityFormPresenter.errorToastTitle',
    defaultMessage: 'Could not update entity',
  },
})
